// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2wYCH","footer":"ModalInfo_footer__2IpJ7"};